import { api } from 'lib/api';
import { ICasinoCollection, ISlotCollection } from 'constants/types';

export interface SiteLayoutData {
  casinoCollections: ICasinoCollection[];
  slotCollections: ISlotCollection[];
  rtpiArticleLink: string;
}

const CACHE_TTL_MS = 60_000;
let cachedLayout: SiteLayoutData | null = null;
let cacheExpiresAt = 0;

export const emptySiteLayout: SiteLayoutData = {
  casinoCollections: [],
  slotCollections: [],
  rtpiArticleLink: '',
};

export async function fetchSiteLayoutData(): Promise<SiteLayoutData> {
  const now = Date.now();

  if (cachedLayout && now < cacheExpiresAt) {
    return cachedLayout;
  }

  const [casinoCollections, slotCollections, rtpiVariable] = await Promise.all([
    api.collections.listCasinoCollections().catch(() => []),
    api.collections.listSlotCollections().catch(() => []),
    api.variables
      .getVariableByName('link-rtpi-article')
      .catch(() => ({ value: '' })),
  ]);

  cachedLayout = {
    casinoCollections,
    slotCollections,
    rtpiArticleLink: rtpiVariable?.value ?? '',
  };
  cacheExpiresAt = now + CACHE_TTL_MS;

  return cachedLayout;
}

export function mergeSiteLayoutProps<T extends Record<string, unknown>>(
  props: T
) {
  return async () => {
    const siteLayout = await fetchSiteLayoutData();
    return { props: { ...props, siteLayout } };
  };
}
